import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseQuestion } from 'src/app/shared/models/baseQuestion';
import { QuestionList } from 'src/app/shared/models/questionList';
import { FaqsSubcategory } from 'src/app/shared/models/subCategory';
import { FRONT_URL } from 'src/environments/environment';

@Component({
  selector: 'faqs-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent {
  @Input() items!: BaseQuestion[];
  @Input() parent!: FaqsSubcategory | QuestionList;
  @Input() isFaqsSubcategory: boolean = true;
  @Output() elementSelected = new EventEmitter();
  readonly url: string = FRONT_URL;

  onElementSelected(
    parent: FaqsSubcategory | QuestionList,
    item: BaseQuestion,
  ): void {
    this.elementSelected.emit({ parent, item });
  }
}
